import React, {  Fragment } from "react";

import { useState } from "react";
import { NavLink , useHistory} from "react-router-dom";

const Navbar = (props) => {
  const [toogleMenu, setToogleMenu] = useState(false)
  const history = useHistory(); // useHistory hook'unu burada kullanın

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Fragment>
      <div className={"wrapper__side-nav-mobile d-flex d-lg-none " + (toogleMenu ? "active" : "")}>
        <div className="d-flex flex-wrap w-100">
          <div className="w-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <NavLink
                to="/"
                exact
                class="navbar-brand font__size--24 text__24-1024 semi-bold color__white"
              >
                Eymen<span className="color__orange">Tel Çit</span>
              </NavLink>
              <img src="./../images/Close.png" onClick={() => setToogleMenu(!toogleMenu)} className="pointer" alt="" />
            </div>
            <div className="menu">
              <NavLink to="/" className="medium font__size--14 text__14-1024 color__white" onClick={handleLinkClick}>Anasayfa</NavLink>
              <hr />
              <hr />
              <NavLink
                to="/hakkimizda" className="medium font__size--14 text__14-1024 color__white" onClick={handleLinkClick}>Hakkımızda</NavLink>
              <hr />
              <hr />
              <NavLink
                to="/servislerimiz" className="medium font__size--14 text__14-1024 color__white" onClick={handleLinkClick}>Servislerimiz</NavLink>
              <hr />
              <hr />
              <NavLink
                to="/referanslarimiz" className="medium font__size--14 text__14-1024 color__white" onClick={handleLinkClick}>Referanslarımız</NavLink>
              <hr />
              <hr />
              <NavLink
                to="/iletisim" className="medium font__size--14 text__14-1024 color__white" onClick={handleLinkClick}>İletişim</NavLink>
              <hr />
              
              
              

            </div>
          </div>
        </div>
      </div >
      <div className="bg__wrap-menu d-lg-none" onClick={() => setToogleMenu(!toogleMenu)}></div>
      <nav
        className="navbar navbar-expand-lg bg__black-2 wrapper__navbar position-relative z-2"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        <div className="container position-relative">
          <NavLink
            to="/"
            exact
            class="navbar-brand font__size--24 text__24-1024 semi-bold color__white"
          >
            Eymen<span className="color__orange">TelÇit</span>
          </NavLink>

          <div
            className="collapse navbar-collapse wrapper__navbar-menu ml-lg-5"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav menu__center">
              <li className="nav-item">
                <NavLink
                  to="/"
                  exact
                  class="nav-link semi-bold font__size--14 text__14-1024 color__white opacity__7 text-uppercase hover"
                >
                  Anasayfa
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/hakkimizda"
                  class="nav-link semi-bold font__size--14 text__14-1024 color__white opacity__7 text-uppercase hover"
                >
                  Hakkımızda
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/servislerimiz"
                  class="nav-link semi-bold font__size--14 text__14-1024 color__white opacity__7 text-uppercase hover"
                >
                  Servislerimiz
                </NavLink>
              </li>
              
              <li className="nav-item">
                <NavLink
                  to="/referanslarimiz"
                  class="nav-link semi-bold font__size--14 text__14-1024 color__white opacity__7 text-uppercase hover"
                >
                  Referanslarımız
                </NavLink>
              </li>
              
              <li className="nav-item">
                <NavLink
                  to="/iletisim"
                  class="nav-link semi-bold font__size--14 text__14-1024 color__white opacity__7 text-uppercase hover"
                >
                  İletişim
                </NavLink>
              </li>
            </ul>
          </div>

          <div
            onClick={() => setToogleMenu(!toogleMenu)}
            class="nav__button d-lg-none position-relative ml-auto flex-shrink-0"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          
        </div>
      </nav>
    </Fragment >
  );
};

export default Navbar;
